import logoBank from "../../public/static/images/svg/payment_bank-transfer_active.svg";
import logoRetail from "../../public/static/images/svg/payment_gerai-retail_active.svg";
import logoHCID from "../../public/static/images/svg/payment_HCID_app_idle.svg";
import logoEcom from "../../public/static/images/svg/payment_ecommerce_idle.svg";
import logoEmon from "../../public/static/images/svg/payment_emoney_idle.svg";
import logoTopup from "../../public/static/images/svg/payment-topup-wallet.png";

export const DataPayment = [
  {
    name: "My Home Credit App",
    image: logoHCID,
    slug: "cara-pembayaran/my-home-credit-app",
    width: "80px"
  },
  {
    name: "Transfer Bank",
    image: logoBank,
    slug: "cara-pembayaran/transfer-bank",
    width: "80px"
  },
  {
    name: "Gerai Retail",
    image: logoRetail,
    slug: "cara-pembayaran/gerai-retail",
    width: "80px"
  },

  {
    name: "E-Commerce",
    image: logoEcom,
    slug: "cara-pembayaran/e-commerce",
    width: "80px"
  },
  {
    name: "Electronic Money",
    image: logoEmon,
    slug: "cara-pembayaran/electronic-money",
    width: "80px"
  },
  {
    name: " Isi Saldo Home Credit Pay",
    image: logoTopup,
    slug: "cara-pembayaran/isi-saldo-home-credit-pay",
    width: "80px"
  }
];
